import { ContentSection } from '@cinch-labs/design-system'
import { renderWithResolver } from '@cinch-nx/landing-ui-shared'

import { CookiesInstructions } from '../../types/policy-page'
import styles from './instructions-table.module.css'

export type Props = {
  instructions: CookiesInstructions[]
}

export const InstructionsTable: React.FC<Props> = ({ instructions }) => (
  <ContentSection>
    <table className={styles.table}>
      <tbody>
        {instructions.map((step) => (
          <tr key={step._uid}>
            <td>
              <p>{step.browser}</p>
            </td>
            <td>{renderWithResolver(step.steps)}</td>
          </tr>
        ))}
      </tbody>
    </table>
  </ContentSection>
)
